module.exports = __webpack_public_path__ + "img/vector.b68b30ff.svg";